const COMPONENT_VISIBILITY_TYPES = {
  all: "all",
  unLogged: "unLogged",
  logged: "logged",
  membersCsc: "member",
};

const LOGIN_PROVIDERS = {
  facebook: "FACEBOOK",
  google: "GOOGLE",
  apple: "APPLE",
};

const COMPONENT_VISIBILITY_ENUM = {
  show: "show",
  hide: "hide",
  default: "default",
};

const DEFAULT_CINEMA_HANDLER = "hradec";

const CINEMA_WILDCARD_HANDLER = "default";

const MOVIE_DETAIL_PROGRAMME_ANCHOR = "#program";

const DEFAULT_CINEMA_LANGUAGE = "cz";

const CINEMA_LANGUAGES = {
  cz: "cz",
  // en: "en",
};

const CINEMA_HANDLERS = {
  boleslav: "boleslav",
  budejovice: "budejovice",
  budejoviceIgy: "budejovice-igy",
  hradec: "hradec",
  jihlava: "jihlava",
  liberec: "liberec",
  olomouc: "olomouc",
  opava: "opava",
  ostrava: "ostrava",
  pardubice: "pardubice",
  plzen: "plzen",
  praha5: "praha5",
  praha9: "praha9",
};

const SCREENING_TYPES = {
  screening: "screening",
  upcoming: "upcoming",
};

const SCREENING_TYPES_GTM = {
  [SCREENING_TYPES.screening]: "promitame_a_predprodej",
  [SCREENING_TYPES.upcoming]: "brzy_uvedeme",
};

const PROMOTION_NAMES_GTM = {
  weekMovie: "Film týdne",
  campaign: "Akce",
};

const CTA_TYPES_GTM = {
  registration: "registration",
  login: "login",
  cinestarClub: "cinestar_club",
};

const MAIN_MOVIE_GROUP_ID = "-2147483648";

const API_ERRORS = {
  API_TOKEN_FAILED: "API_TOKEN_FAILED",
  E_X_CLIENT_ERROR: "E_X_CLIENT_ERROR",
  E_API_ALREADY_AUTHORIZED: "E_API_ALREADY_AUTHORIZED",
  E_API_TOKEN_NOT_FOUND: "E_API_TOKEN_NOT_FOUND",
  API_TOKEN_VALIDITY_EXCEEDED: "API_TOKEN_VALIDITY_EXCEEDED",
  API_TOKEN_MAX_USES_EXCEEDED: "API_TOKEN_MAX_USES_EXCEEDED",
  API_TOKEN_MISSING: "API_TOKEN_MISSING",
};

// Value Sets precomputed once so the validity predicates are O(1) with no per-call
// allocation (Object.values() rebuilt a fresh array on every call). Single source of truth
// stays CINEMA_HANDLERS/CINEMA_LANGUAGES — add an entry there and it is honored here too.
const CINEMA_SLUG_SET = new Set(Object.values(CINEMA_HANDLERS));
const CINEMA_LANGUAGE_SET = new Set(Object.values(CINEMA_LANGUAGES));

const isValidCinemaSlug = (cinemaSlug) => {
  return CINEMA_SLUG_SET.has(cinemaSlug);
};

const isValidCinemaLang = (cinemaSlug) => {
  return CINEMA_LANGUAGE_SET.has(cinemaSlug);
};

const isValidCinemaPath = (cinemaLang, cinemaSlug) => {
  return isValidCinemaLang(cinemaLang) && isValidCinemaSlug(cinemaSlug);
};

const HEADERS_NAMES = {
  authToken: "Token",
  clientUUID: "X-Client",
};

const COOKIES_NAMES = {
  token: "token",
  clientUUID: "x-client",
  profilePicture: "profilePicture",
  ref: "ref",
  weekMoviesActiveIndex: "weekMoviesActiveIndex",
  refreshToken: "REFRESH_TOKEN",
  lastVisitedLocation: "lastVisitedLocation",
};

export {
  HEADERS_NAMES,
  COOKIES_NAMES,
  COMPONENT_VISIBILITY_TYPES,
  LOGIN_PROVIDERS,
  COMPONENT_VISIBILITY_ENUM,
  DEFAULT_CINEMA_HANDLER,
  CINEMA_WILDCARD_HANDLER,
  MOVIE_DETAIL_PROGRAMME_ANCHOR,
  DEFAULT_CINEMA_LANGUAGE,
  CINEMA_LANGUAGES,
  MAIN_MOVIE_GROUP_ID,
  API_ERRORS,
  SCREENING_TYPES,
  SCREENING_TYPES_GTM,
  PROMOTION_NAMES_GTM,
  CTA_TYPES_GTM,
  isValidCinemaSlug,
  isValidCinemaLang,
  isValidCinemaPath,
};
